import { render } from "./ClientTopbar.vue?vue&type=template&id=46d73941"
import script from "./ClientTopbar.vue?vue&type=script&lang=js"
export * from "./ClientTopbar.vue?vue&type=script&lang=js"

import "./ClientTopbar.vue?vue&type=style&index=0&id=46d73941&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__